module.exports = __webpack_public_path__ + "static/media/visual_appraisal_mobile.39f234f2.png";